const topicsData = [
  { tag: '隐婚风波', posts: '12.8 万讨论', hot: true },
  { tag: '网红互撕', posts: '9.6 万讨论', hot: true },
  { tag: '综艺翻车', posts: '7.3 万讨论', hot: true },
  { tag: '品牌解约', posts: '6.1 万讨论', hot: true },
  { tag: '学历造假', posts: '5.4 万讨论', hot: false },
  { tag: '恋情曝光', posts: '4.9 万讨论', hot: false },
  { tag: '直播事故', posts: '4.2 万讨论', hot: false },
  { tag: '选秀黑幕', posts: '3.8 万讨论', hot: false },
  { tag: '代言风波', posts: '3.1 万讨论', hot: false },
  { tag: '转会争议', posts: '2.7 万讨论', hot: false },
  { tag: '聊天记录外泄', posts: '2.3 万讨论', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">话题热榜</h2>
          <p className="mt-2 text-sm text-foreground-600">当下最热门的八卦话题标签，点击探索更多精彩内容</p>
        </div>

        <div className="flex flex-wrap gap-3">
          {topicsData.map((item, i) => (
            <div
              key={i}
              className="group cursor-pointer flex items-center gap-3 px-5 py-3 rounded-2xl border border-background-200/70 bg-background-50 hover:border-accent-300/50 hover:bg-accent-50/30 transition-all duration-200"
            >
              <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                #{item.tag}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.posts}</span>
              {item.hot && (
                <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-fire-line text-xs"></i>
                </span>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs text-foreground-500">
            以上话题基于近 7 天全网数据实时计算，数据来源：微博、抖音、小红书
          </p>
        </div>
      </div>
    </section>
  );
}